import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container mar_b" }
const _hoisted_2 = {
  key: 0,
  class: "detail_content detail_content_bj"
}
const _hoisted_3 = {
  key: 1,
  class: "detail_content detail_content_bj"
}
const _hoisted_4 = { style: {"font-weight":"bold","padding-top":"10px","padding-left":"13px","text-align":"center"} }
const _hoisted_5 = { class: "next_btn" }

import { useRouter,useRoute } from "vue-router"
    import {reactive, ref, toRefs} from "vue"
    import {ElMessage} from "element-plus";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'notic',
  setup(__props) {

    const checked = ref(false)
    const router = useRouter()
    const route = useRoute()

    const data = reactive({
        query: {} as any
    })

    const nextOne = async() => {
      if (!checked.value && data.query.tagName == 'gzcn'){
        ElMessage.warning('请勾选我已阅读并确认上述《网上申报注意事项》')
        return;
      }
        let params = {
            serviceCode: data.query.serviceCode,
            serviceName: data.query.serviceName,
            ismp: data.query.ismp,
            tagName: data.query.tagName
        }
        toPath('./declaration', params)
    }

    const toPath = (path: string, params: any) => {
        router.push({
            path: path,
            query: params
        })
    }

    const getQueryData = () => {
        data.query = route.query
        console.log('data.query',data.query);
    }

    const init = () => {
        getQueryData()
    }

    init()


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[14] || (_cache[14] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "t6_breadCream" }, [
          _createElementVNode("span", null, "首页"),
          _createTextVNode(),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, "一件事"),
          _createTextVNode(),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, "告知承诺")
        ], -1)),
        (data.query.tagName != 'gzcn')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("h1", { style: {"color":"#2185F2"} }, "网上办事承诺书", -1),
              _createElementVNode("p", {
                class: "detail_til",
                style: {"font-weight":"bold"}
              }, "本单位（本人）自愿申请成为“网上办事大厅”用户，并郑重承诺如下：", -1),
              _createElementVNode("p", null, "本单位（本人）同意并接受《网上办事服务条款》所有内容。", -1),
              _createElementVNode("p", null, "在取得“网上办事大厅”合法用户身份后，应妥善管理用户密码及数字证书，严格遵循国家有关法规、政策及社保业务规范，保证提交业务数据及资料的真实、准确，并对有关资料妥善留存、归档，按业务审批机构要求提供审验。 ", -1),
              _createElementVNode("p", null, "如违反以上承诺造成的不良后果，本单位（本人）行为将纳入不良诚信记录,并承担全部责任。", -1),
              _createElementVNode("div", { class: "etail_content_bt" }, [
                _createElementVNode("span", { style: {"color":"#E33232"} }, "注：本承诺书经用户签署后立即生效，直至注销其用户资格为止。")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (data.query.tagName == 'gzcn')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"color":"#2185F2"} }, "告知承诺书", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "1. 申请人使用网上审批大厅申报事项，应充分了解办事指南及网上申报的操作步骤；", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "2. 申请人在网上申报过程中请按要求填写申报表单，并认真核对，确保网上申报内容真实、正确和完整。提交时系统将对所填报信息进行格式化审查，如不符合填写要求，系统会予以提示； ", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "3. 申请人提交申请材料可选择网上申报和窗口递交两种方式： ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", { style: {"text-indent":"45px"} }, " ①申请人选择网上申报进行材料上传时，需按要求提交正确格式和大小的电子文档；申请人进行证照验证时，需按要求正确填写相关证照信息，提交后系统将做自动比对；", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", { style: {"text-indent":"45px"} }, " ②申请人选择窗口递交时，直接前往申请部门窗口提交相关申请材料。 ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "4. 由于申请人的原因造成网上申报数据信息与纸质材料不一致的，由申请人承担相应的民事法律责任；申请人在使用网上申报功能时，须自觉遵守国家有关法律法规的规定； ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("p", null, "5. 申请人选择办理结果速递送达服务方式，请先阅读速递服务指南，并按照系统提示填报寄件人信息（速递服务免费）；", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("p", null, "6. 网上申报提交成功后，申请人可通过网站、短信、邮件等方式查询。", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_checkbox, {
                  modelValue: checked.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("我已阅读并确认上述《网上申报注意事项》", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: nextOne,
            size: "large",
            color: "#4ACAB6",
            style: {"color":"#fff"}
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("跳转事项申报", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})